import cardBg from "../../assets/img/updated-bg.png";
import Logo from "../../assets/img/vq-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { LinearProgress } from "@mui/material";
import Config from "../../Config";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Col from "react-bootstrap/Col";

function Home() {
  // const [accountNumber, setAccountNumber] = useState(false);
  // const [email, setEmail] = useState(false);
  const [inputValues, setInputValues] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const { id } = useParams();
  let btnClassName = 'bg-red-300';

  const navigate = useNavigate();


  const handleChange = ({ target }) => {

    setInputValues({
      ...inputValues,
      [target.id]: target.value
    });
  }

  const handleSubmit = async () => {
    setIsLoading(true);

    const url = Config.API_URL + "checkDetails";
    const payload = {
      account_no: inputValues.accountNumber,
      email: inputValues.email,
      id: id,
    };

    axios
      .post(url, payload)
      .then(function (response) {
        setIsLoading(false);

        if (response.data[0].status === "success") {
          let payment = {
            amount: response.data[0].amount,
            orderId: response.data[0].orderID,
            vcode: response.data[0].vcode,
            name: response.data[0].bill_name,
            email: response.data[0].bill_email,
            mobile: response.data[0].bill_mobile,
            account_no: inputValues.accountNumber,
            id: id,
          };

          navigate("/payment-details", { state: payment });
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        let message = "";

        if (error.response.data[0]) {
          message = error.response.data[0].msg;
        } else {
          message = "All fields are required!.";
        }

        Swal.fire({
          title: "Error!",
          html: message,
          icon: "error",
          confirmButtonText: "Okay",
        });
      });
  };

  useEffect(()=>{
    document.title = "Home";
    
    localStorage.clear();
  })

  return (
    <div className="content-center justify-center items-center flex h-screen align-middle">
      <div className="card lg:card-side bg-base-100 shadow-xl p-6 xl:w-3/5 md:w-screen  " style={{borderRadius: '65px', minHeight: '500px'}}>
        <div className="card-body text-black grid lg:grid-cols-2 flex-row-reverse">
          <div className="lg:col-span-1">
            <div className="text-left w-250 h-100 m-0 p-0 align-baseline  items-start flex pb-10">
              <img src={`${Logo}`} alt="" className=" w-250 h-100 m-0 p-0" />
            </div>

            {isLoading && (
              <div className="mt-3 mb-3">
                <p> 	
                  Loading... <span>Please Wait..</span>
                </p>
                <LinearProgress color="error"/>
              </div>
            )}
            <h1 className="md:text-6xl text-2xl font-bold text-left mb-2 pb-5">Payment Portal</h1>
            <p className="md:text-2xl text-sm mt-1 font-semibold text-left mb-4 pb-5">
              Welcome to the online payment portal <br />
              for ViewQwest customers!
            </p>

            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold text-base">Account Number:</span>
              </label>
              <label className="input-group">
                <input
                  type="text"
                  className="input input-bordered w-full"
                  value={inputValues.accountNumber}
                  id="accountNumber"
                  onChange={handleChange}
                  required
                />
                <span>
                  <FontAwesomeIcon icon={faUser} />
                </span>
              </label>
            </div>

            <div className="form-control">
              <label className="label">
                <span className="label-text font-semibold text-base">Email</span>
              </label>
              <label className="input-group">
                <input
                  type="email"
                  className="input input-bordered w-full"
                  value={inputValues.email}
                  id="email"
                  onChange={handleChange}
                  required
                />
                <span>
                  <FontAwesomeIcon icon={faEnvelope} />
                </span>
              </label>
            </div>
            <div className="text-left ">
              <button
                className={`text-white bg-red-600 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-xl text-sm px-7 py-2.5 text-center mr-2 mb-2 mt-3`}
                disabled={isLoading}
                onClick={handleSubmit}
                id="submit  "
                type="submit"
              >
                Login
              </button>
            </div>
          </div>

          <div className="lg:order-last order-first lg:col-span-1 align-middle content-center justify-center items-center flex">
            <img src={`${cardBg}`} alt="Album" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
